// src/pages/RegistrationFuiteDonnees/components/UI/FormInput.tsx
import React from 'react';
import './FormInput.scss';

interface FormInputProps {
  label: string;
  placeholder: string;
  name: string;
  type?: string;
  icon?: React.ReactNode;
  required?: boolean;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string | boolean;
}

const FormInput: React.FC<FormInputProps> = ({
                                               label,
                                               placeholder,
                                               name,
                                               type = 'text',
                                               icon,
                                               required = false,
                                               value,
                                               onChange,
                                               onBlur,
                                               error
                                             }) => {
  return (
    <div className="UI-input-form">
      <div className="form-input">
        <label htmlFor={name} className="form-input__label">
          {label}
        </label>

        <div className="form-input__wrapper">
          {icon && (
            <div className="form-input__icon">
              {icon}
            </div>
          )}

          <input
            id={name}
            name={name}
            type={type}
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className={`form-input__field ${error ? 'error' : ''}`}
          />
        </div>

        {error && (
          <div className="form-input__error">{error}</div>
        )}
      </div>
    </div>
  );
};

export default FormInput;